<template>
  <div>
    <v-stepper v-model="verticalStep" vertical :color="insurer.color">
      <!-- 1️ TIPOLOGIA (SEGURADO) -->
      <v-stepper-step
        step="1"
        :complete="verticalStep > 1"
        editable
        :color="insurer.color"
      >
        Tipologia
      </v-stepper-step>

      <v-stepper-content step="1">
        <RiskLocationTypologyStep
          v-model="insuredRiskTypology"
          @complete="goToDamages"
          :insurer="insurer"
        />

        <StepperActions
          :showBack="false"
          @next="verticalStep = 2"
          :insurer="insurer"
        />
      </v-stepper-content>

      <!-- 2️ DANOS -->
      <v-stepper-step
        step="2"
        :complete="verticalStep > 2"
        editable
        :color="insurer.color"
      >
        Danos
      </v-stepper-step>

      <v-stepper-content step="2">
        <DamageGallery ref="damages" :insurer="insurer" />

        <StepperActions
          @back="verticalStep = 1"
          @next="verticalStep = 3"
          :insurer="insurer"
        />
      </v-stepper-content>

      <!-- 3️ DOCUMENTOS -->
      <v-stepper-step
        step="3"
        :complete="verticalStep > 3"
        editable
        :color="insurer.color"
      >
        Documentos
      </v-stepper-step>

      <v-stepper-content step="3">
        <div class="text--secondary mb-4">
          Anexar documentos e comprovativos.
        </div>

        <RiskLocationDocumentsStep :insurer="insurer" />
        <StepperActions
          @back="verticalStep = 2"
          @next="verticalStep = 4"
          :insurer="insurer"
        />
      </v-stepper-content>

      <!-- 4️ OUTROS LESADOS -->
      <v-stepper-step step="4" editable :color="insurer.color">
        Outros lesados
      </v-stepper-step>

      <v-stepper-content step="4">
        <OtherInjuredsStep
          :participants="participants"
          @update="handleParticipantsUpdate"
          :insurer="insurer"
        />
        <StepperActions
          @back="verticalStep = 3"
          @next="finishRiskLocation"
          :insurer="insurer"
        />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import RiskLocationTypologyStep from "./RiskLocationTypologyStep.vue";
import DamageGallery from "./DamageGallery.vue";
import OtherInjuredsStep from "./OtherInjuredsStep.vue";
import StepperActions from "./StepperActions.vue";
import RiskLocationDocumentsStep from "./RiskLocationDocumentsStep.vue";

export default {
  name: "RiskLocationDNA",

  components: {
    RiskLocationTypologyStep,
    DamageGallery,
    OtherInjuredsStep,
    StepperActions,
    RiskLocationDocumentsStep,
  },

  data() {
    return {
      verticalStep: 1,
      participants: [],
    };
  },

  props: {
    insurer: Object,
    initialVerticalStep: {
      type: Number,
      default: null,
    },
  },

  methods: {
    finishRiskLocation() {
      // sobe para o stepper horizontal (Confirmação DNA)
      this.$emit("continue");
    },

    loadParticipants() {
      const raw = localStorage.getItem("participants");
      this.participants = raw ? JSON.parse(raw) : [];
    },

    saveParticipants() {
      localStorage.setItem("participants", JSON.stringify(this.participants));
    },

    handleParticipantsUpdate(updated) {
      this.participants = updated;
      this.saveParticipants();
    },

    goToDamages() {
      this.verticalStep = 2;
    },
  },

  computed: {
    insuredRiskTypology: {
      get() {
        const insured = this.participants.find(
          (p) => p.participant_type?.canonical === "insured"
        );

        return insured?.risk_location_typology || null;
      },
      set(value) {
        this.participants = this.participants.map((p) =>
          p.participant_type?.canonical === "insured"
            ? { ...p, risk_location_typology: value }
            : p
        );

        this.saveParticipants();
      },
    },
  },

  created() {
    this.loadParticipants();
  },

  watch: {
    initialVerticalStep: {
      immediate: true,
      handler(step) {
        if (step) {
          this.verticalStep = step;
        }
      },
    },
  },
};
</script>
